//@ts-nocheck
import { Route, Routes } from "react-router-dom";
import Account_suspended from "../pages/AccountSuspended";



/**
 * Top level application router
 *
 * @returns {JSX.Element}
 */
const Router = () => {
  return (
    <Routes>
      <Route path={"/account-suspended"} element={<Account_suspended />} />
    </Routes>
  );
};

export default Router;
